jQuery(document).ready(function () {
    initDnTextareaTinyMce();
});


var initDnTextareaTinyMce = function () {

    if (typeof tinymce === 'undefined') {
        return;
    }

    tinymce.remove();
    tinymce.init({
        selector:'.dnFormTextareaTinyMce-field',
        menubar:false,
        statusbar: false,
        plugins: ['code', 'link', 'paste', 'autoresize'],
        toolbar: ['bold | italic | cut | copy | paste | undo | redo | link'],
        width: '700',
        height: '200',
        paste_as_text: true,
        invalid_elements: "pre",
        forced_root_block: "p",
        skin: 'dn',
        init_instance_callback: function (editor) {
            editor.on('focus', function (e) {
                $(editor.contentAreaContainer).closest('.dnFormTextarea-container').addClass('dnFormTextarea-container-focus');
            });
            editor.on('blur', function (e) {
                $(editor.contentAreaContainer).closest('.dnFormTextarea-container').removeClass('dnFormTextarea-container-focus');
            });
        }
    });
};

$(document).on('loaded.form.ajax', function (e) {
    initDnTextareaTinyMce();
});
